import axios from "axios";
import React, { useEffect, useState } from "react";
import { Usuario } from "../../../Models/Cadastros/Usuario/Usuario";
import { useSnackbar } from "notistack";
import PopupBasePage from "../../../Components/Base/BasePopup";
import UsuarioDadosTab from "./UsuarioDadosTab";
import UsuarioFiltroAcessosTab from "./UsuarioFiltroAcessosTab";
import UsuarioOperacoesTab from "./UsuarioOperacoesTab";
import UsuarioTecnologiasTab from "./UsuarioTecnologiasTab";
import UsuarioPaineis from "./UsuarioPaineisTab";
import TabHeaderComponent from "../../../Components/Navigations/SimpleTabHeaderComponent";
import TabPanelComponent from "../../../Components/Navigations/SimpleTabPanelComponent";

const UsuarioCadastroPopup = (props: any) => {
    const [tabValue, setTabValue] = React.useState(0);
    const [usuario, setUsuario] = useState<any>(new Usuario());
    const [perfis, setPerfis] = useState<any[]>([]);
    const [tecnologias, setTecnologias] = useState<any[]>([]);
    const { enqueueSnackbar } = useSnackbar();

    useEffect(() => {
        (async () => {
            if ((props.usuario?.id ?? 0) != 0) {
                setUsuario(props.usuario);
            }

            let responsePerfis: any = await axios.get('perfis');
            setPerfis(responsePerfis.data);

            let responseTecnologia: any = await axios.get(`buscaTecnologias`);
            setTecnologias(responseTecnologia.data);
        })();
    }, []);
    
    async function save() {
        try {
            let responseId: any = null;
            if (usuario?.id == null ||usuario?.id == 0 || usuario?.id == '') {
                let response = await axios.post('usuarios', usuario);
                responseId = response.data.usuario_id;
            }
            else {
                let response = await axios.put(`usuarios/${usuario.id}`, usuario);
                responseId = response.data.usuario_id;
            }

            enqueueSnackbar('Salvo com sucesso!', {variant: 'success'});
            let responseUsuario: any = await axios.get(`buscaUsuarioPorId?id=${responseId}`);
            setUsuario(responseUsuario.data);
        } catch (error) {
            enqueueSnackbar('Erro ao salvar!', {variant: 'error'});
        }
        finally {
            document.body.style.cursor = "default";
        }
    }
    
    return (
        <PopupBasePage title="Usuário" isOpen={props.isOpen} onClose={props.onClose} onClickFirstButtonPopupCallback={save} isPesquisa='false' confirmClose={true}>
            <div className="container">
                <div className="row">
                    <div className="align-all-left col-md-12 order-md-1">
                        <TabHeaderComponent setTabValueEventCallBack={setTabValue} label="Cadastro Usuário" tabs={['Dados', 'Filtros', 'Operações', 'Tecnologias', 'Paineis Power BI']} tab="usuario" />

                        <form className="needs-validation" id="formUsuarioDados">
                            <TabPanelComponent value={tabValue} index={0} tab="usuario" tabHeader="usuario">
                                <UsuarioDadosTab usuario={usuario} perfis={perfis} />
                            </TabPanelComponent>
                        </form>

                        <TabPanelComponent value={tabValue} index={1} tab="usuario" tabHeader="usuario">
                            <UsuarioFiltroAcessosTab usuario={usuario} />
                        </TabPanelComponent>

                        <TabPanelComponent value={tabValue} index={2} tab="operacao" tabHeader="usuario">
                            <UsuarioOperacoesTab usuario={usuario} />
                        </TabPanelComponent>

                        <TabPanelComponent value={tabValue} index={3} tab="tecnologia" tabHeader="usuario">
                            <UsuarioTecnologiasTab usuario={usuario} tecnologias={tecnologias} />
                        </TabPanelComponent>

                        <TabPanelComponent value={tabValue} index={4} tab="painel" tabHeader="usuario">
                            <UsuarioPaineis usuario={usuario} />
                        </TabPanelComponent>
                    </div>
                </div>
            </div >
        </PopupBasePage >
    );
}

export default UsuarioCadastroPopup;